module.exports = __webpack_public_path__ + "media/images/horse-d3e680fd8f691deef41a1ffb9ce4debc.gif";